import { useCart } from '../../contexts/CartContext';
import { CartIconContainer, CartBadge, CartSvg } from './styles';

interface CartIconProps {
  onClick: () => void;
}

export const CartIcon = ({ onClick }: CartIconProps) => {
  const { getTotalItems } = useCart();
  const itemCount = getTotalItems();

  return (
    <CartIconContainer onClick={onClick}>
      <CartSvg 
        xmlns="http://www.w3.org/2000/svg" 
        viewBox="0 0 24 24" 
        width="24" 
        height="24"
      >
        <path d="M7 18c-1.1 0-1.99.9-1.99 2S5.9 22 7 22s2-.9 2-2-.9-2-2-2zM1 2v2h2l3.6 7.59-1.35 2.45c-.16.28-.25.61-.25.96 0 1.1.9 2 2 2h12v-2H7.42c-.14 0-.25-.11-.25-.25l.03-.12.9-1.63h7.45c.75 0 1.41-.41 1.75-1.03l3.58-6.49c.08-.14.12-.31.12-.48 0-.55-.45-1-1-1H5.21l-.94-2H1zm16 16c-1.1 0-1.99.9-1.99 2s.89 2 1.99 2 2-.9 2-2-.9-2-2-2z"/>
        <path d="M18 8h-2V6c0-2.21-1.79-4-4-4S8 3.79 8 6v2H6v8h12V8zm-6-4c1.1 0 2 .9 2 2v2h-4V6c0-1.1.9-2 2-2z"/>
      </CartSvg>
      {itemCount > 0 && <CartBadge>{itemCount}</CartBadge>}
    </CartIconContainer>
  );
};